export const ShowProductsOnPaymentStep = {
    name: 'show_products_on_payment_step',
    variations: {
        Original: 'original',
        Show: 'show',
    },
};

export const ClickCollectAvailableBeforeZipin = {
    name: 'clickcollect_available_before_zipin',
    variations: {
        Original: 'original',
        Available: 'available',
    },
};

export const AciNotification = {
    name: 'aci_notifications',
    variations: {
        Original: 'original',
        Show: 'show',
    },
};

export const DiscountCode = {
    key: 'discount_code',
    variations: {
        Show: 'show',
        Hide: 'hide',
    },
};

export const HideBgImage = {
    key: 'hide_bg_image',
    variations: {
        Show: 'show',
        Hide: 'hide',
    },
};
